import axios from 'axios';
import { getAuthFromLocalStorage, removeAuthFromLocalStorage } from './storage';
import { confirmExpiredTokenAlert } from '../components/common/ConfirmExpiredTokenAlert';
import { commonAlert } from '../components/common/CommonAlert';

const axiosServices = axios.create({
  baseURL: `${process.env.REACT_APP_ENDPOINT}`,
  headers: {
    'Content-type': 'application/json',
    Accept: 'application/json'
  }
});

// Add a request interceptor to handle token refresh
axiosServices.interceptors.request.use(async config => {
  const auth = getAuthFromLocalStorage();
  if (auth?.dhToken) {
    config.headers.Authorization = `Bearer ${auth.dhToken}`;
  }
  return config;
});
let isAlertShown = false; // Flag to prevent multiple alerts
axiosServices.interceptors.response.use(
  async response => {
    return response;
  },
  async error => {
    if (error.response?.status === 401 && !isAlertShown) {
      isAlertShown = true;
      confirmExpiredTokenAlert().then(resp => {
        if (resp) {
          redirectToLoginPage();
        }
      });
    } else if (error.response?.status === 409) {
      commonAlert({
        title: 'Error',
        textColor: 'danger',
        message: error.response?.data?.message || 'Something went wrong'
      });
      return Promise.reject(error.response || 'Something went wrong');
    } else {
      return Promise.reject(error.response || 'Something went wrong');
    }
  }
);

const redirectToLoginPage = () => {
  removeAuthFromLocalStorage();
  window.location.href = window.location.origin + '/auth/sign-in';
};

export default axiosServices;
